module.exports = __webpack_public_path__ + "img/2.8d99f4e0.png";